function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-282 -58)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.389,
  height: 2.821,
  rx: 1.41,
  transform: "translate(282 58)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  width: 16.926,
  height: 2.821,
  rx: 1.41,
  transform: "translate(282 65.052)",
  fill: "#222"
}));

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.389,
    height: 9.873,
    viewBox: "0 0 25.389 9.873"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Menu.69da2a7c.svg";
export { SvgMenu as ReactComponent };